module.exports = __webpack_public_path__ + "img/img-antros.fd8b1f7d.webp";